module.exports = __webpack_public_path__ + "static/media/alumio-vertical.9fb64f52.svg";